<template>
  <router-view />
</template>

<script setup>
import { onBeforeUnmount, onMounted } from "vue";

import { startPlanExecutionTracker, stopPlanExecutionTracker } from "./stores/planExecutions.js";

onMounted(() => {
  void startPlanExecutionTracker();
});

onBeforeUnmount(() => {
  stopPlanExecutionTracker();
});
</script>
